import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div
        className="max-w-5xl mx-auto rounded-xl bg-cover bg-center relative overflow-hidden"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Warm%20inviting%20digital%20manga%20reading%20environment%20with%20soft%20lighting%2C%20cozy%20reading%20nook%20with%20digital%20tablet%20displaying%20colorful%20comic%20pages%2C%20warm%20coral%20and%20amber%20gradient%20background%2C%20Japanese%20aesthetic%20with%20modern%20tech%20elements%2C%20professional%20clean%20composition&width=1400&height=600&seq=cta-manga-banner&orientation=landscape)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>
        <div className="relative z-10 py-16 md:py-20 px-6 md:px-12 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
            准备好开启漫画之旅了吗？
          </h2>
          <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-6 md:mb-8">
            立即访问禁漫天官方平台，海量漫画资源等你来发现
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/article/1"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-rocket-line text-sm"></i>
              </div>
              立即访问
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full text-sm md:text-base font-medium hover:bg-white/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-information-line text-sm"></i>
              </div>
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}